export default {
  createVariable: 'Zdefiniuj nową zmienną',
};
